"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const de_ui_1 = require("@delab-team/de-ui");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const svg_selector_1 = require("../../assets/svg-selector");
const app_card_module_css_1 = __importDefault(require("./app-card.module.css"));
const AppCard = ({ preview_img, app_link, title, description, isTg }) => {
    const TgObj = sdk_1.default;
    const handleClick = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (app_link.startsWith('https://t.me')) {
            TgObj.openTelegramLink(app_link);
        }
        else {
            // window.open(app_link, '_blank')
            TgObj.openLink(app_link);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: app_card_module_css_1.default.card, onClick: handleClick, children: [(0, jsx_runtime_1.jsx)("div", { className: app_card_module_css_1.default.imgWrapper, children: (0, jsx_runtime_1.jsx)("img", { src: preview_img, className: app_card_module_css_1.default.cardImg, alt: title, width: "40", height: "40" }) }), (0, jsx_runtime_1.jsxs)("div", { className: app_card_module_css_1.default.cardBody, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: app_card_module_css_1.default.cardTitle, children: title }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: app_card_module_css_1.default.cardDescription, children: description })] }), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "chevron-right-gray", isTg: isTg })] })] }));
};
exports.AppCard = AppCard;
